

import SingleDatePicker from "components/input-range-data";
import { useFiltersState } from "../../ducks/filter/hooks/state";
import { useFiltersActions } from "../../ducks/filter/hooks/action";

export default function SelectFilters() {
  const { fromDate, toDate } = useFiltersState();
  const { updateFromDate, updateToDate } = useFiltersActions();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <div className="flex-1">
          <SingleDatePicker
            id="from-date"
            date={fromDate || undefined}
            onDateChange={(date) => updateFromDate(date || null)}
            label="De:"
          />
        </div>
        <div className="flex-1">
          <SingleDatePicker
            id="to-date"
            date={toDate || undefined}
            onDateChange={(date) => updateToDate(date || null)}
            label="Até:"
          />
        </div>
      </div>
    </div>
  );
}
